import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\BatchOperation\GetBatchOperationAutomationsController::__invoke
* @see app/Http/Controllers/BatchOperation/GetBatchOperationAutomationsController.php
* @route '/api/batch-operations/automations'
*/
const GetBatchOperationAutomationsController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetBatchOperationAutomationsController.url(options),
    method: 'get',
})

GetBatchOperationAutomationsController.definition = {
    methods: ["get","head"],
    url: '/api/batch-operations/automations',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\BatchOperation\GetBatchOperationAutomationsController::__invoke
* @see app/Http/Controllers/BatchOperation/GetBatchOperationAutomationsController.php
* @route '/api/batch-operations/automations'
*/
GetBatchOperationAutomationsController.url = (options?: RouteQueryOptions) => {
    return GetBatchOperationAutomationsController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\BatchOperation\GetBatchOperationAutomationsController::__invoke
* @see app/Http/Controllers/BatchOperation/GetBatchOperationAutomationsController.php
* @route '/api/batch-operations/automations'
*/
GetBatchOperationAutomationsController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetBatchOperationAutomationsController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\BatchOperation\GetBatchOperationAutomationsController::__invoke
* @see app/Http/Controllers/BatchOperation/GetBatchOperationAutomationsController.php
* @route '/api/batch-operations/automations'
*/
GetBatchOperationAutomationsController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetBatchOperationAutomationsController.url(options),
    method: 'head',
})

export default GetBatchOperationAutomationsController